var map = {
	"./breakText/locale/en.js": 15006,
	"./breakText/locale/es.js": 21513,
	"./breakText/locale/pt.js": 19637,
	"./cryptogramGenerator/locale/en.js": 99849,
	"./cryptogramGenerator/locale/es.js": 43870,
	"./cryptogramGenerator/locale/pt.js": 10166,
	"./fences/locale/en.js": 96436,
	"./fences/locale/es.js": 19367,
	"./fences/locale/pt.js": 87375,
	"./generate/locale/en.js": 32945,
	"./generate/locale/es.js": 51606,
	"./generate/locale/pt.js": 85870,
	"./huntingWordsGenerator/locale/en.js": 67211,
	"./huntingWordsGenerator/locale/es.js": 62240,
	"./huntingWordsGenerator/locale/pt.js": 13788,
	"./letrex/locale/en.js": 67602,
	"./letrex/locale/es.js": 49957,
	"./letrex/locale/pt.js": 66241,
	"./loop/locale/en.js": 84996,
	"./loop/locale/es.js": 823,
	"./loop/locale/pt.js": 98559,
	"./numberSquare/locale/en.js": 83260,
	"./numberSquare/locale/es.js": 89535,
	"./numberSquare/locale/pt.js": 14407,
	"./numerex/locale/en.js": 11124,
	"./numerex/locale/es.js": 36935,
	"./numerex/locale/pt.js": 62415,
	"./puzzle/locale/en.js": 74474,
	"./puzzle/locale/es.js": 41261,
	"./puzzle/locale/pt.js": 70185,
	"./puzzleTerm/locale/en.js": 23960,
	"./puzzleTerm/locale/es.js": 59187,
	"./puzzleTerm/locale/pt.js": 41899,
	"./settings/locale/en.js": 20595,
	"./settings/locale/es.js": 85368,
	"./settings/locale/pt.js": 68436,
	"./shapeLinks/locale/en.js": 74148,
	"./shapeLinks/locale/es.js": 32503,
	"./shapeLinks/locale/pt.js": 27359,
	"./specialCharacterRemover/locale/en.js": 92494,
	"./specialCharacterRemover/locale/es.js": 48153,
	"./specialCharacterRemover/locale/pt.js": 96773,
	"./user/locale/en.js": 25649,
	"./user/locale/es.js": 44310,
	"./user/locale/pt.js": 78574,
	"./walls/locale/en.js": 64191,
	"./walls/locale/es.js": 81212,
	"./walls/locale/pt.js": 20248,
	"./word/locale/en.js": 56770,
	"./word/locale/es.js": 35381,
	"./word/locale/pt.js": 79665,
	"./wordGroups/locale/en.js": 59866,
	"./wordGroups/locale/es.js": 26845,
	"./wordGroups/locale/pt.js": 67161,
	"./wordSeparator/locale/en.js": 69581,
	"./wordSeparator/locale/es.js": 60266,
	"./wordSeparator/locale/pt.js": 89106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48653;